import { IComboBoxOption } from "@fluentui/react";
import { Guid, ReadonlyCollection } from "@ioip/core/lib";
import { IObject } from "../../portal/types";
import { CProject } from "../../projects";
import { EntityType } from "../../types";
import Attribute from "./Attribute";
import { IExtendedEntitySchema } from "./IExtendedEntitySchema";
import { EntityView } from "./EntityView";

export interface IEntityProps {
    object: IObject<IExtendedEntitySchema>;
    project: CProject;
}

export default class Entity {

    #props: IEntityProps;
    #attributes: ReadonlyCollection<Attribute>;
    #view: ReadonlyCollection<EntityView>;

    constructor(props: IEntityProps) {
        this.#props = props;
        const attributes = props.object.schema.attributes ?? [];
        const views = props.object.schema.views ?? [];
        this.#attributes = new ReadonlyCollection<Attribute>(attributes.map(schema => new Attribute({ schema: schema, entity: this })));
        this.#view = new ReadonlyCollection<EntityView>(views.map(schema => new EntityView({ schema: schema, entity: this, engine: null })));
    }

    get objectId(): string {
        return this.#props.object.objectId;
    }

    get name(): string {
        return this.#props.object.name;
    }

    get code(): string {
        return this.#props.object.code;
    }

    get description(): string {
        return this.#props.object.description;
    }

    get type(): EntityType {
        return this.#props.object.schema.type;
    }

    get isMainEntity(): boolean {
        return this.#props.object.name === 'TProceso';
    }

    get enabled(): boolean {
        return this.#props.object.enabled ?? false;
    }

    get path(): string {
        return this.#props.object.schema.path;
    }

    get attributes(): ReadonlyCollection<Attribute> {
        return this.#attributes;
    }

    get views(): ReadonlyCollection<EntityView> {
        return this.#view;
    }

    get fluentUi(): IComboBoxOption {
        return {
            key: this.#props.object.objectId,
            text: `${this.name} (${this.code})`
        }
    }

    get primaryKey(): Attribute {
        return this.#attributes.firstOrDefault(x => x.isPrimaryKey);
    }

    get foreignKeys(): Attribute[] {
        const foreignKeys = this.#props.object.schema.foreignKeys || [];
        return this.#attributes.where(x => foreignKeys.includes(x.id.toString())).toArray();
    }

    get project(): CProject {
        return this.#props.project;
    }

    get isNative(): boolean {
        return this.#props.object.schema.isNative ?? false;
    }

    get isParameter(): boolean {
        return this.#props.object.schema.isParameter ?? false;
    }

    getAttribute(attributeId: string | Guid): Attribute {
        if (attributeId instanceof Guid) {
            const id = attributeId.toString();
            return this.#attributes.firstOrDefault(x => x.id == id);
        } else if (Guid.isValid(attributeId)) {
            return this.#attributes.firstOrDefault(x => x.id == attributeId);
        }
        return this.#attributes.firstOrDefault(x => x.code === attributeId);
    }

    #buildViews = () => {
        // const views = this.#props.schema.views || [];
        // for (let i = 0; i < views.length; i++) {
        //     const schema = views[ i ];
        //     const view = new EntityView({ schema, entity: this, engine: this.#props.sdk });
        //     this.views.push(view);
        // }
    }

}
